export const customDateRange = {value: 'custom:date-range', label: 'Date Range'}
export const today = {value: 'day:0', label: 'Today'}
export const yesterday = {value: 'day:-1', label: 'Yesterday'}
export const tomorrow = {value: 'day:1', label: 'Tomorrow'}
export const thisWeek = {value: 'week:0', label: 'This Week'}
export const lastWeek = {value: 'week:-1', label: 'Last Week'}
export const nextWeek = {value: 'week:1', label: 'Next Week'}
export const lastMonth = {value: 'month:-1', label: 'Last Month'}
export const thisMonth = {value: 'month:0', label: 'This Month'}
export const nextMonth = {value: 'month:1', label: 'Next Month'}
export const lastQuarter = {value: 'quarter:-1', label: 'Last Quarter'}
export const thisQuarter = {value: 'quarter:0', label: 'This Quarter'}
export const nextQuarter = {value: 'quarter:1', label: 'Next Quarter'}
export const lastFinancialQuarter = {value: 'fquarter:-1', label: 'Last Financial Quarter'}
export const thisFinancialQuarter = {value: 'fquarter:0', label: 'This Financial Quarter'}
export const nextFinancialQuarter = {value: 'fquarter:1', label: 'Next Financial Quarter'}
export const lastYear = {value: 'year:-1', label: 'Last Year'}
export const thisYear = {value: 'year:0', label: 'This Year'}
export const nextYear = {value: 'year:1', label: 'Next Year'}
export const lastFinancialYear = {value: 'fyear:-1', label: 'Last Financial Year'}
export const thisFinancialYear = {value: 'fyear:0', label: 'This Financial Year'}
export const nextFinancialYear = {value: 'fyear:1', label: 'Next Financial Year'}
export const last24hours = {value: 'days:-1', label: 'Last 24 Hours'}
export const last2Days = {value: 'days:-2', label: 'Last 2 Days'}
export const last3Days = {value: 'days:-3', label: 'Last 3 Days'}
export const last7Days = {value: 'days:-7', label: 'Last 7 Days'}
export const last14Days = {value: 'days:-14', label: 'Last 14 Days'}
export const last30Days = {value: 'days:-30', label: 'Last 30 Days'}
export const last60Days = {value: 'days:-60', label: 'Last 60 Days'}
export const last90Days = {value: 'days:-90', label: 'Last 90 Days'}
export const next24Hours = {value: 'days:1', label: 'Next 24 Hours'}
export const next2Days = {value: 'days:2', label: 'Next 2 Days'}
export const next3Days = {value: 'days:3', label: 'Next 3 Days'}
export const next7Days = {value: 'days:7', label: 'Next 7 Days'}
export const next14Days = {value: 'days:14', label: 'Next 14 Days'}
export const next30Days = {value: 'days:30', label: 'Next 30 Days'}
export const next60Days = {value: 'days:60', label: 'Next 60 Days'}
export const next90Days = {value: 'days:90', label: 'Next 90 Days'}

export const getDateRangeSelectors = [
  today,
  yesterday,
  tomorrow,
  thisWeek,
  lastWeek,
  nextWeek,
  lastMonth,
  thisMonth,
  nextMonth,
  lastQuarter,
  thisQuarter,
  nextQuarter,
  lastFinancialQuarter,
  thisFinancialQuarter,
  nextFinancialQuarter,
  lastYear,
  thisYear,
  nextYear,
  lastFinancialYear,
  thisFinancialYear,
  nextFinancialYear,
  last24hours,
  last2Days,
  last3Days,
  last7Days,
  last14Days,
  last30Days,
  last60Days,
  last90Days,
  next24Hours,
  next2Days,
  next3Days,
  next7Days,
  next14Days,
  next30Days,
  next60Days,
  next90Days,
]

